var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "select",
    {
      directives: [
        {
          name: "model",
          rawName: "v-model",
          value: _vm.currentlySelectedTypeObject,
          expression: "currentlySelectedTypeObject"
        }
      ],
      staticClass: "form-control",
      attrs: { id: "simple_question_type_selector_" + _vm.id },
      on: {
        change: function($event) {
          var $$selectedVal = Array.prototype.filter
            .call($event.target.options, function(o) {
              return o.selected
            })
            .map(function(o) {
              var val = "_value" in o ? o._value : o.value
              return val
            })
          _vm.currentlySelectedTypeObject = $event.target.multiple
            ? $$selectedVal
            : $$selectedVal[0]
        }
      }
    },
    _vm._l(_vm.structureArray, function(groupStructureArray, groupTitle) {
      return _c(
        "optgroup",
        {
          key: groupTitle,
          attrs: { label: groupStructureArray.questionGroupName }
        },
        _vm._l(groupStructureArray.questionTypes, function(questionType) {
          return _c(
            "option",
            {
              key: questionType.type + questionType.name,
              domProps: { value: questionType }
            },
            [
              _vm._v("\n        " + _vm._s(questionType.title) + " \n        "),
              _vm.debug
                ? _c("em", { staticClass: "small" }, [
                    _vm._v(
                      _vm._s(_vm._f("translate")("Type:")) +
                        " " +
                        _vm._s(questionType.type)
                    )
                  ])
                : _vm._e()
            ]
          )
        }),
        0
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }